import React from 'react';
import { toast } from 'react-toastify';
import "../components/style.scss"
const Checkout = () => {
    function displayRazorpay(total){
      toast.warn("In Production of this site, payment is done using Razorpay Gateway")
    };
    return (
        <div className="bg-light">
            <div className="container">
                <div className="py-5 text-center">
                    <img src={process.env.PUBLIC_URL + "/images/logo_new.png"} alt="cloudcart" className="commerciallogo"/>
                    <h2>Checkout form</h2>
                </div>
                <div className="row">
                    <div className="col-md-4 order-md-2 mb-4">
                        <h4 className="d-flex justify-content-between align-items-center mb-3">
                        <span className="text-muted">Your cart</span>
                        </h4>
                        <ul className="list-group mb-3">
                            
                            <li className="list-group-item d-flex justify-content-between bg-light">
            
                            </li>
                            <li className="list-group-item d-flex justify-content-between">
                                <span>Total</span>
                            <strong>4965</strong>
                            </li>
                        </ul>
                        <form className="card p-2">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Promo code"/>
                                <div className="input-group-append">
                                    <button type="submit" className="btn btn-secondary">Redeem</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-8 order-md-1">
                        <h4 className="mb-3">Billing address</h4>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="firstName">First name</label>
                                    <input type="text" className="form-control" id="firstName" placeholder="First name" required/>
                                    <div className="invalid-feedback">
                                    Valid first name is required.
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="lastName">Last name</label>
                                    <input type="text" className="form-control" id="lastName" placeholder="Last name" required/>
                                    <div className="invalid-feedback">
                                    Valid last name is required.
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email">Email <span className="text-muted">(Optional)</span></label>
                                <input type="email" className="form-control" id="email" placeholder="you@example.com"/>
                                <div className="invalid-feedback">
                                Please enter a valid email address for shipping updates.
                                </div>
                            </div>
                            <hr className="mb-4"/>
                            <button className="btn btn-primary btn-lg btn-block" onClick={displayRazorpay}>Continue to checkout</button>
                    </div>
                </div>     
                <footer className="my-5 pt-5 text-muted text-center text-small">
                    <p className="mb-1">&copy; 2020-2021 CloudCart</p>
                    <ul className="list-inline">
                        <li className="list-inline-item">Privacy</li>
                        <li className="list-inline-item">Terms</li>
                        <li className="list-inline-item">Support</li>
                    </ul>
                </footer>
            </div>             
        </div>
    );
};
export default Checkout;